import React, { createContext, useContext, useState } from "react";
import GlobalDrawer from "../../components/GlobalDrawer/GlobarDrawer";


const GlobalDrawerContext = createContext();

export const GlobalDrawerProvider = ({ children }) => {

    const [drawerContent, setDrawerContent] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [drawerBgColor, setDrawerBgColor] = useState(
        "bg-[#070A12]/96 backdrop-blur-2xl border-l border-white/10"
    );
    const [drawerWidth, setDrawerWidth] = useState(400);
    const [status,setStatus] = useState('show')
    const openDrawer = (content, options = {}) => {
        const opts = typeof options === "string" ? { bgColor: options } : options || {};
        setDrawerContent(content);
        setDrawerBgColor(
            opts.bgColor ||
                "bg-[#070A12]/96 backdrop-blur-2xl border-l border-white/10"
        );
        setDrawerWidth(opts.width || 400);
        setStatus(opts.status || "show");
        setIsOpen(true);
        localStorage.setItem("action", opts.status || "show");
    };


    const closeDrawer = () => {
        setIsOpen(false);
        setDrawerContent(null); // Очищаем контент при закрытии
    };

    return (
        <GlobalDrawerContext.Provider value={{ openDrawer, closeDrawer }}>
            {children}
            <GlobalDrawer
                isOpen={isOpen}
                onClose={closeDrawer}
                drawerBgColor={drawerBgColor}
                width={drawerWidth}
                status={status}
            >
                {drawerContent}
            </GlobalDrawer>
        </GlobalDrawerContext.Provider>
    );
};

export const useGlobalDrawer = () => useContext(GlobalDrawerContext);
